import { ChangeEvent } from 'react';

import styles from './RangeSlider.module.css';

export function RangeSlider({
  className = '',
  steps = 1,
  value = 0,
  onChange,
}: {
  value: number;
  steps: number;
  className?: string;
  onChange?: (step: number) => void;
}) {
  function handleOnChange(evt: ChangeEvent<HTMLInputElement>) {
    try {
      const value = evt.target?.value || '';
      const parsed = parseInt(value, 10);
      onChange?.(parsed);
    } catch (_) {
      // Silently ignore
    }
  }

  return (
    <input
      type="range"
      min="0"
      max={Math.max(0, steps - 1)}
      step="1"
      value={value}
      className={`${styles.range} ${className}`}
      onChange={handleOnChange}
    />
  );
}
